import BaseModelInstance from './base.model'
import { SystemSetting as ModelDefinition } from './model-definitions'

class SystemSetting extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default SystemSetting
